import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { setLenis, scrollToTop } from "@/lib/scroll";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Destinatari from "@/components/landing/Destinatari";
import Programma from "@/components/landing/Programma";
import Requisiti from "@/components/landing/Requisiti";
import Prezzo from "@/components/landing/Prezzo";
import Testimonianze from "@/components/landing/Testimonianze";
import LeadForm from "@/components/landing/LeadForm";
import FAQ from "@/components/landing/FAQ";
import Contatti from "@/components/landing/Contatti";
import Footer from "@/components/landing/Footer";
import MobileCTA from "@/components/landing/MobileCTA";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import Privacy from "@/pages/Privacy";

function Landing() {
  return (
    <div className="min-h-screen bg-paper font-body text-ink antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Destinatari />
        <Programma />
        <Requisiti />
        <Prezzo />
        <Testimonianze />
        <LeadForm />
        <FAQ />
        <Contatti />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <WhatsAppFloat />
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}

